<template>
  <div class="download-app-sticky-header" v-if="isMobile">
    <div class="download-app-sticky-header__container">
      <div class="download-app-sticky-header__logo">
        <BaseSvgIcon name="emcd" />
      </div>
      <div class="download-app-sticky-header__right">
        <div class="download-app-sticky-header__info">
          <div class="download-app-sticky-header__title">EMCD Wallet</div>
          <div class="download-app-sticky-header__subtitle">
            {{ t("DownloadAppStickyHeader | Subtitle") }}
          </div>
        </div>
        <a
          class="download-app-sticky-header__button"
          :href="downloadUrl"
          target="_blank"
          rel="noopener noreferrer"
          @click.prevent="handleClick"
        >
          {{ t("DownloadAppStickyHeader | ButtonText") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { BaseSvgIcon } from "@/shared/ui";
import "@/assets/icons/SVG/emcd.svg";
import { useBreakpoints } from "@/shared/utils/ui/useBreakpoints";

const { t } = useI18n();

const downloadUrl = "https://emcd.onelink.me/rSKK/explorer";
const { isMobile } = useBreakpoints();

const handleClick = () => {
  window.emcd.AnalyticsService.track("click", {
    event_type: "click",
    product: "explorer",
    button_name: "onelink_click",
    utm_source: "onelink_explorer",
  });
  window.open(downloadUrl, "_blank");
};
</script>

<style lang="scss">
.download-app-sticky-header {
  background: #fff;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 16px 0;
  display: flex;
  justify-content: center;
  @media (min-width: 769px) {
    display: none;
  }

  &__container {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }

  &__right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
  }

  &__logo {
    display: flex;
    align-items: center;
    padding: 11px;
    border-radius: 12px;
    background: #000;
    color: #fafafa;
    margin-right: 10px;

    .svg-icon {
      width: 35px;
      height: 35px;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    margin-right: 24px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    line-height: 1.3;
  }

  &__subtitle {
    font-size: 16px;
    color: #7a7a7a;
    line-height: 1.3;
    font-weight: 500;

    @media (max-width: 768px) {
      font-size: 13px;
    }
  }

  &__button {
    background: #8f42ff;
    color: #fafafa;
    border: none;
    border-radius: 100px;
    padding: 10px 16px;
    font-size: 12px;
    font-weight: 500;
    text-decoration: none;
    transition: background 0.2s;
    cursor: pointer;
  }
}
</style>
